<template>
  <v-row no-gutters>
    <v-col v-if="isFetched" cols="12">
      <sidebar-row>
        <v-col cols="12" class="px-0">
          <relations-input :data-source-name="dataSourceName" :feature-id="featureId" />
        </v-col>
      </sidebar-row>
      <v-row no-gutters>
        <v-col cols="12" class="px-0">
          <relations-list :data-source-name="dataSourceName" :feature-id="featureId" />
        </v-col>
      </v-row>
    </v-col>
    <main-loader v-else />
  </v-row>
</template>
<script>
import MainLoader from '@/components/MainLoader';
import RelationsInput from '@/components/RelationsInput';
import RelationsList from '@/components/RelationsList';
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'Relations',
  components: { MainLoader, RelationsInput, RelationsList, SidebarRow },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
    initFunction: {
      type: Function,
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    async init() {
      this.isFetched = false;
      try {
        await this.initFunction({
          data_source_name: this.dataSourceName,
          feature_id: this.featureId,
        });
        this.isFetched = true;
      } catch {
        this.isFetched = true;
      }
    },
  },
  watch: {
    featureId() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
